import { Link } from 'react-router-dom';
import HeroCarousel from './components/HeroCarousel';
import CategoryEntries from './components/CategoryEntries';
import HotRankList from './components/HotRankList';
import MediaCard from '@/components/base/MediaCard';
import NewsCard from '@/components/base/NewsCard';
import SectionHeader from '@/components/base/SectionHeader';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import { mediaList } from '@/mocks/movies';
import { newsList } from '@/mocks/news';
import { aboutStats } from '@/mocks/home';

export default function Home() {
  useDocumentMeta({
    title: '粉色水蜜桃影视大全 - 电视剧电影剧情介绍与资讯',
    description:
      '粉色水蜜桃提供丰富的电视剧、电影资源和影视资讯，涵盖剧情介绍、演员信息和最新动态，帮助用户方便浏览和了解各类影视作品。',
    keywords:
      '粉色水蜜桃,影视大全,电视剧,电影,剧情介绍,演员资讯,影视资源,影视动态',
  });

  const latest = [...mediaList]
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
    .slice(0, 8);
  const hot = [...mediaList].sort((a, b) => b.heat - a.heat).slice(0, 5);
  const latestNews = newsList.slice(0, 6);

  return (
    <>
      <HeroCarousel />

      <section className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeader
          eyebrow="快速入口"
          title="按分类浏览影视资源"
          subtitle="电视剧、电影与热门专题，一键直达你感兴趣的内容"
        />
        <CategoryEntries />
      </section>

      <section className="bg-background-100">
        <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
            <div className="lg:col-span-2">
              <SectionHeader
                eyebrow="最新上线"
                title="最新影视推荐"
                moreLink="/category"
                moreText="进入分类页"
              />
              <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:gap-5">
                {latest.map((item) => (
                  <MediaCard key={item.id} item={item} />
                ))}
              </div>
            </div>

            <div>
              <SectionHeader eyebrow="人气榜单" title="热门影视推荐" />
              <HotRankList items={hot} />
            </div>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
        <SectionHeader
          eyebrow="影视资讯"
          title="最新影视资讯"
          subtitle="电影新闻、电视剧动态与行业观察，把握影视圈最新风向"
          moreLink="/news"
          moreText="全部资讯"
        />
        {latestNews.length > 0 ? (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {latestNews.map((item) => (
              <NewsCard key={item.id} item={item} />
            ))}
          </div>
        ) : (
          <div className="rounded-lg border border-background-200 bg-background-50 p-10 text-center text-sm text-foreground-500">
            资讯加载失败，请稍后重试
          </div>
        )}
      </section>

      <section className="bg-primary-50">
        <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
          <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
            <div>
              <p className="mb-2 text-xs font-semibold uppercase tracking-[0.18em] text-primary-600">
                关于粉色水蜜桃
              </p>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                一个认真整理影视内容的资讯站
              </h2>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
                粉色水蜜桃聚焦电视剧与电影两大类内容，为你整理剧情介绍、演员资料与分类筛选，让你在寻找想看的内容时不再迷失。所有数据均为演示示例，不含真实播放与下载功能。
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <Link
                  to="/about"
                  className="flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer dark:text-foreground-950"
                >
                  了解我们
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
                <Link
                  to="/search"
                  className="flex items-center gap-2 whitespace-nowrap rounded-full border border-primary-300 px-6 py-3 text-sm font-medium text-primary-700 transition-colors hover:bg-background-50 cursor-pointer"
                >
                  <i className="ri-search-line" aria-hidden="true"></i>
                  搜索影视
                </Link>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              {aboutStats.map((stat) => (
                <div
                  key={stat.label}
                  className="rounded-lg border border-primary-100 bg-background-50 p-5"
                >
                  <p className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">
                    {stat.value}
                  </p>
                  <p className="mt-1.5 text-sm text-foreground-600">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}